
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 44 44","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M22 42c11.046 0 20-8.954 20-20S33.046 2 22 2 2 10.954 2 22s8.954 20 20 20zm0 2C9.85 44 0 34.15 0 22S9.85 0 22 0s22 9.85 22 22-9.85 22-22 22z"}}),_c('path',{attrs:{"d":"M14 31.333V12.667h5.333v18.666H14zm10.667-18.666H30v18.666h-5.333V12.667z"}})])
      }
    
      }
    